import { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { getAuthState, getOnboardingState } from '../store/selectors';
import { setUserPushNotifications } from '../store/actions';
import {
  isPushNotificationSupported,
  askUserPermission,
  registerServiceWorker,
  createNotificationSubscription,
  getUserSubscription,
} from './utility/configPushNotifications';
// import all the function created to manage the push notifications

const pushNotificationSupported = isPushNotificationSupported();
// first thing to do: check if the push notifications are supported by the browser

function PushNotification(props) {
  const [userConsent, setSuserConsent] = useState(Notification.permission);
  // to manage the user consent: Notification.permission is a JavaScript native function that return the current state of the permission
  // We initialize the userConsent with that value
  const isConsentGranted = userConsent === 'granted';

  // Initialize these variables outside of useEffect() or any click handler to be able to build
  const tempPropsSetUserPushNotifications = props.setUserPushNotifications;
  const tempAuthToken = props.auth.jwtToken;

  const onClickSusbribeToPushNotification = useCallback(() => {
    createNotificationSubscription()
      .then((subscription) => {
        if (subscription) {
          const subscriptionObject = subscription.toJSON();

          tempPropsSetUserPushNotifications(subscriptionObject, tempAuthToken);
        }
      })
      .catch((err) => {
        console.error(
          "Couldn't create the notification subscription",
          err,
          'name:',
          err.name,
          'message:',
          err.message,
          'code:',
          err.code
        );
      });
  }, [tempAuthToken, tempPropsSetUserPushNotifications]);

  /**
   * define a click handler that asks the user permission,
   * it uses the setSuserConsent state, to set the consent of the user
   * If the user denies the consent, an error is created with the setError hook
   */
  const onClickAskUserPermission = useCallback(() => {
    askUserPermission().then((consent) => {
      setSuserConsent(consent);
      onClickSusbribeToPushNotification();
    });
  }, [onClickSusbribeToPushNotification]);

  // If the push notifications are supported, registers the service worker
  // this effect runs only the first render
  useEffect(() => {
    if (pushNotificationSupported) {
      registerServiceWorker();
    }

    async function getExixtingSubscription() {
      const existingSubscription = await getUserSubscription();

      return existingSubscription !== null;
    }

    // Can the browser support notifications and has the user allowed them?
    async function userPermission() {
      // If the user already has a subscription
      const userHasSubscription = await getExixtingSubscription();

      if (userHasSubscription === true) {
        // do nothing
      } else {
        return !pushNotificationSupported || !isConsentGranted
          ? onClickAskUserPermission()
          : onClickSusbribeToPushNotification();
      }
    }

    userPermission();
  }, [
    isConsentGranted,
    onClickAskUserPermission,
    onClickSusbribeToPushNotification,
  ]);

  return null;
}

function mapStateToProps(state) {
  const onboarding = getOnboardingState(state);
  const auth = getAuthState(state);

  return { onboarding, auth };
}

export default connect(mapStateToProps, { setUserPushNotifications })(
  PushNotification
);
